module.exports = {"id":"212469","name":"Aly Ghazal","rating":"73","photo":"./data/images/photos/4/212469.png","club":{"name":"Whitecaps FC","logo":"./data/images/clubs/WhitecapsFC.png"},"positions":["MDC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlyGhazal0.json
// module id = 308
// module chunks = 0